import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, createContext, useContext, useEffect, } from 'react';
import { useFormContext } from 'react-hook-form';
import { runIfFn } from '@tribeplatform/react-ui-kit/utils';
import { useI18n } from '../../i18n';
const ConfirmDiscardContext = createContext(undefined);
function useConfirmDiscardContext() {
    const context = useContext(ConfirmDiscardContext);
    if (context === undefined) {
        throw new Error('useConfirmDiscardContext must be used within a ConfirmDiscardProvider');
    }
    return context;
}
export const ConfirmDiscard = ({ children, onConfirm, active = true, message, }) => {
    const intl = useI18n();
    const [dirty, setDirty] = useState(false);
    const discard = useCallback(() => {
        if (!active || !dirty) {
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
            return;
        }
        // eslint-disable-next-line no-alert
        const confirmed = window.confirm(message ||
            intl.$t({
                id: 'Alert.UnsavedChanges',
                defaultMessage: 'You have unsaved changes. Are you sure you want to discard them?',
            }));
        if (confirmed) {
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
            setDirty(false);
        }
    }, [onConfirm, dirty, active, message, intl]);
    return (_jsx(ConfirmDiscardContext.Provider, { value: { setDirty }, children: runIfFn(children, {
            discard,
        }) }, void 0));
};
const FormDirtyUpdater = () => {
    const { formState: { isDirty }, } = useFormContext();
    const { setDirty } = useConfirmDiscardContext();
    useEffect(() => {
        setDirty(isDirty);
    }, [isDirty, setDirty]);
    return null;
};
ConfirmDiscard.FormDirty = FormDirtyUpdater;
//# sourceMappingURL=ConfirmDiscard.js.map